import { useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useCatalog } from "../context/Catalog";
import { useTramite } from "../context/Tramite";
import "./css/components.css";
import { buscarUnidad, listarTiposTanque } from "../api/General";
import { isInvalid } from "../utils/forms";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import QuestionField from "./controls/QuestionField";
import ArrayField from "./controls/ArrayField";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TanqueAcopioLiquidoForm from "./TanqueAcopioLiquidoForm";
import { TanqueAcopioLiquidoList } from "./TanqueAcopioLiquidoList";
import { crearTanqueAcopioLiquido } from "../utils/data";

export default function AcopioLiquidosForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const tiposTanqueCatalog = useCatalog(["tiposTanque"], () =>
    listarTiposTanque(null),
  );
  const unidadMetroCatalog = useCatalog(["unidad", "M"], () =>
    buscarUnidad("M"),
  );
  const unidadVolumenCatalog = useCatalog(["unidad", "M3"], () =>
    buscarUnidad("M3"),
  );
  const loading =
    tiposTanqueCatalog.loading ||
    unidadMetroCatalog.loading ||
    unidadVolumenCatalog.loading;
  const handleConEvaporacionLiquidosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleConMovimientoLiquidosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleConAcopioLiquidosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  const handleTanquesAcopioLiquidosChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    if (!tramiteForm.values?.conAcopioLiquidos) {
      tramiteForm.setFieldValue("tanquesAcopioLiquidos", [], false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tramiteForm.values?.conAcopioLiquidos]);
  return (
    <Loader loading={loading}>
      <Grid>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conEvaporacionLiquidos"
              name="conEvaporacionLiquidos"
              label={t("tramite.conEvaporacionLiquidos")}
              value={tramiteForm.values?.conEvaporacionLiquidos}
              onChange={handleConEvaporacionLiquidosChange}
              isInvalid={isInvalid("conEvaporacionLiquidos", tramiteForm)}
              error={t(tramiteForm.errors.conEvaporacionLiquidos)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conMovimientoLiquidos"
              name="conMovimientoLiquidos"
              label={t("tramite.conMovimientoLiquidos")}
              value={tramiteForm.values?.conMovimientoLiquidos}
              onChange={handleConMovimientoLiquidosChange}
              isInvalid={isInvalid("conMovimientoLiquidos", tramiteForm)}
              error={t(tramiteForm.errors.conMovimientoLiquidos)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <QuestionField
              id="conAcopioLiquidos"
              name="conAcopioLiquidos"
              label={t("tramite.conAcopioLiquidos")}
              value={tramiteForm.values?.conAcopioLiquidos}
              onChange={handleConAcopioLiquidosChange}
              isInvalid={isInvalid("conAcopioLiquidos", tramiteForm)}
              error={t(tramiteForm.errors.conAcopioLiquidos)}
              disabled={!isEditable(tramite)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <ArrayField
              id="tanquesAcopioLiquidos"
              name="tanquesAcopioLiquidos"
              label={t("tramite.tanquesAcopioLiquidos")}
              value={tramiteForm.values?.tanquesAcopioLiquidos}
              onChange={handleTanquesAcopioLiquidosChange}
              createItem={crearTanqueAcopioLiquido}
              isInvalid={isInvalid("tanquesAcopioLiquidos", tramiteForm)}
              error={
                (tramiteForm.errors.tanquesAcopioLiquidos instanceof Array &&
                  t("errors.tramite.tanquesAcopioLiquido.many")) ||
                t(tramiteForm.errors.tanquesAcopioLiquidos)
              }
              disabled={
                !isEditable(tramite) || !tramiteForm.values?.conAcopioLiquidos
              }
            >
              {({
                value: tanquesAcopioLiquidos,
                append,
                remove,
                select,
                replace,
                selectedItem,
                selectedIndex,
                disabled,
              }) => (
                <Grid>
                  {!disabled && (
                    <Row>
                      <Col>
                        <TanqueAcopioLiquidoForm
                          value={selectedItem}
                          page={selectedIndex}
                          pages={tanquesAcopioLiquidos.length}
                          select={select}
                          append={append}
                          replace={replace}
                          remove={remove}
                          tiposTanque={tiposTanqueCatalog.data}
                          unidadAltura={unidadMetroCatalog.data}
                          unidadAlturaLiquido={unidadMetroCatalog.data}
                          unidadDiametro={unidadMetroCatalog.data}
                          unidadVolumen={unidadVolumenCatalog.data}
                          unidadVolumenTotal={unidadVolumenCatalog.data}
                          disabled={disabled}
                        />
                      </Col>
                    </Row>
                  )}
                  <Row>
                    <Col>
                      <TanqueAcopioLiquidoList
                        value={tanquesAcopioLiquidos}
                        select={select}
                        remove={remove}
                        disabled={disabled}
                      />
                    </Col>
                  </Row>
                </Grid>
              )}
            </ArrayField>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
